import { render, staticRenderFns } from "./TyumenPage.vue?vue&type=template&id=272d16c4"
import script from "./TyumenPage.vue?vue&type=script&lang=js"
export * from "./TyumenPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports